import { render, staticRenderFns } from "./SupportTicketCard.vue?vue&type=template&id=444e23f7&"
import script from "./SupportTicketCard.vue?vue&type=script&lang=js&"
export * from "./SupportTicketCard.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketCard.vue?vue&type=style&index=0&id=444e23f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports